// extracted by mini-css-extract-plugin
export default {"panel":"Offices_panel__YHaZ8"};